export const SELLER_APPLICATION_ID =
  "amzn1.sp.solution.17ad6c50-e28c-4e3c-87f2-7cea42bf4fe0";

export const SELLER_CENTRAL_CONSENT_URL =
  "https://sellercentral.amazon.in/apps/authorize/consent";

export const VENDOR_CENTRAL_CONSENT_URL =
  "https://vendorcentral.amazon.com/apps/authorize/consent";

const PORTAL_STORAGE_KEY = "amazon_sp_onboarding_portal";

export const onboardingRedirectUri = () =>
  `${window.location.origin}/onboarding-amazon`;

export const buildOnboardingState = (clientId, accountName, tokenId) =>
  JSON.stringify({
    clientId: clientId == null ? "" : String(clientId),
    accountName: (accountName || "").trim(),
    tokenId: tokenId || "",
  });

export const parseOnboardingState = (state) => {
  if (!state) return { clientId: "", accountName: "", tokenId: "" };
  try {
    const parsed = JSON.parse(state);
    if (parsed && typeof parsed === "object") {
      return {
        clientId: parsed.clientId == null ? "" : String(parsed.clientId),
        accountName:
          parsed.accountName == null ? "" : String(parsed.accountName).trim(),
        tokenId: parsed.tokenId == null ? "" : String(parsed.tokenId),
      };
    }
  } catch {
    return { clientId: String(state), accountName: "", tokenId: "" };
  }
  return { clientId: String(state), accountName: "", tokenId: "" };
};

export const rememberOnboardingPortal = (portal) => {
  const value = portal === "vendor" ? "vendor" : "seller";
  localStorage.setItem(PORTAL_STORAGE_KEY, value);
  sessionStorage.setItem(PORTAL_STORAGE_KEY, value);
};

export const readOnboardingPortal = () =>
  sessionStorage.getItem(PORTAL_STORAGE_KEY) ||
  localStorage.getItem(PORTAL_STORAGE_KEY) ||
  "";

export const readStoredClientId = () => {
  try {
    const raw = localStorage.getItem("clientId");
    if (!raw) return "";
    const parsed = JSON.parse(raw);
    return parsed == null ? "" : String(parsed);
  } catch {
    return "";
  }
};

export const buildSellerConsentUrl = (clientId, accountName, tokenId) => {
  const params = new URLSearchParams({
    application_id: SELLER_APPLICATION_ID,
    redirect_uri: onboardingRedirectUri(),
    state: buildOnboardingState(clientId, accountName, tokenId),
  });
  return `${SELLER_CENTRAL_CONSENT_URL}?${params.toString()}`;
};

export const buildVendorConsentUrl = (clientId, accountName, tokenId) => {
  const params = new URLSearchParams({
    application_id: SELLER_APPLICATION_ID,
    redirect_uri: onboardingRedirectUri(),
    state: buildOnboardingState(clientId, accountName, tokenId),
    version: "beta",
  });
  return `${VENDOR_CENTRAL_CONSENT_URL}?${params.toString()}`;
};

export const isAllowedAmazonCallback = (callbackUri) => {
  try {
    const url = new URL(callbackUri);
    if (url.protocol !== "https:") return false;
    const host = url.hostname.toLowerCase();
    return ["amazon.com", "amazon.in"].some(
      (suffix) => host === suffix || host.endsWith(`.${suffix}`)
    );
  } catch {
    return false;
  }
};

export const portalFromAmazonCallback = (callbackUri) => {
  try {
    const host = new URL(callbackUri).hostname.toLowerCase();
    if (host.includes("vendorcentral")) return "vendor";
    if (host.includes("sellercentral")) return "seller";
  } catch {
    return "";
  }
  return "";
};

export const resolveAmazonCallbackUri = (callbackUri) => {
  if (!callbackUri) return "";
  if (isAllowedAmazonCallback(callbackUri)) return callbackUri;
  try {
    const decoded = decodeURIComponent(callbackUri);
    if (isAllowedAmazonCallback(decoded)) return decoded;
  } catch {
    return callbackUri;
  }
  return callbackUri;
};

export const buildAmazonConfirmUrl = ({
  callbackUri,
  amazonState,
  version,
  clientId,
  accountName,
}) => {
  const url = new URL(callbackUri);
  url.searchParams.set("redirect_uri", onboardingRedirectUri());
  url.searchParams.set("amazon_state", amazonState || "");
  const state = buildOnboardingState(
    clientId || readStoredClientId(),
    accountName
  );
  if (state) url.searchParams.set("state", state);
  if (version) url.searchParams.set("version", version);
  return url.toString();
};
